import { Tooltip } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import { Tag } from 'ui'

import { type ListPrice as ListPriceType } from 'typings'
import { messages } from './messages'

type ListPriceProps = {
  listPrice: ListPriceType
}

export function ListPrice(props: ListPriceProps) {
  const { listPrice } = props
  const { $t } = useIntl()

  if (!listPrice) return null

  return (
    <Tooltip text={$t(messages.listPrice.tooltip[listPrice])}>
      <Tag>
        <FormattedMessage {...messages.listPrice.tag[listPrice]} />
      </Tag>
    </Tooltip>
  )
}
